/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Kết Bạn Mới, Chat, Giao Lưu",
      "Số điện thoại không đúng",
      "Get the app",
      "Tiếp tục bằng Apple",
      "Tiếp tục qua Facebook",
      "Tiếp tục qua Google",
      "Đăng nhập",
      "Đăng ký",
      "Để tiếp tục, vui lòng nhập các ký tự bạn nhìn thấy.",
      "Tiếp tục",
      "Điền ký tự bạn thấy",
      "Kiểm tra an toàn",
      "Tải lại",
      "Tạo mật khẩu mới mà bạn nhớ dễ dàng:",
      "Cập nhật",
      "Xác nhận mật khẩu",
      "Mật khẩu phải ít nhất {{num}} [[characters:num]]",
      "Mật khẩu",
      "Tạo mật khẩu mới",
      "Badoo - The Blog",
      "Tuyển dụng",
      "Chat",
      "Thành phố",
      "Quản lý Cookies",
      "Copyright © 2006 – present. Bumble. All rights reserved.",
      "Apple và logo Apple là thương hiệu của Apple Inc.{{__EOL__}}Google Play là thương hiệu của Google LLC.",
      "Tải về",
      "Facebook",
      "Theo dõi chúng tôi",
      "Trung Tâm Hỗ Trợ",
      "Instagram",
      "Ngôn ngữ",
      "LinkedIn",
      "Tổng Quan",
      "Badoo là một phần của Bumble Inc.",
      "Chính Sách Bảo Mật",
      "Safety Centre",
      "Sitemap",
      "Tuyên bố về Đạo Luật Nô Lệ Hiện Đại",
      "Điều Khoản và Điều Kiện",
      "Twitter",
      "Điền email hoặc số động của bạn và chúng tôi sẽ gửi bạn hướng dẫn tạo mật khẩu mới.",
      "Tạo mật khẩu mới",
      "Điền email hoặc số di động",
      "Quên mật khẩu",
      "Các mô hình được sử dụng cho mục đích minh họa",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Không cần phải đợi kết đôi.{{__EOL__}}{{__EOL__}}Đi sâu vào cuộc trò chuyện và đi thẳng vào nội dung. Bạn biết đấy, khoảnh khắc mà các bạn thực sự hiểu nhau.",
      "Sẵn sàng chat ngay?",
      "Khi đăng ký, bạn đồng ý <a class=\"link\" href=\"{{terms_url}}\">Điều khoản & Điều kiện</a>. Tìm hiểu cách chúng tôi sử dụng dữ liệu của bạn trong <a class=\"link\" href=\"{{privacy_url}}\">Chính sách quyền riêng tư</a>.",
      "Giúp thể hiện nhiều hơn con người thật của bạn, <br /> để hẹn hò người mà bạn cảm thấy thích.",
      "Hẹn hò với sự tự tin",
      "Hoặc",
      "Đã có tài khoản?",
      "Đăng ký bằng email hoặc số điện thoại",
      "Đạt được điều bạn muốn khi hẹn hò.{{__EOL__}}Không cần phải xin lỗi.",
      "Chỉ muốn chat? Không sao.{{__EOL__}}Bạn đã sẵn sàng ổn định cuộc sống? Rất thích điều đó.{{__EOL__}}{{__EOL__}}Và nếu bạn thay đổi quyết định, bạn hoàn toàn có thể.",
      "Muốn hẹn hò",
      "Tìm kiếm một mối quan hệ",
      "Muốn trò chuyện",
      "Gặp gỡ những người muốn điều tương tự.",
      "{{name}}, {{age}}",
      "An toàn của bạn là ưu tiên số một của chúng tôi.",
      "Safety Centre là trung tâm kiến thức bao gồm tất cả sự hỗ trợ mà bạn cần để có thể tự tin hẹn hò.",
      "Truy cập Safety Centre",
      "An toàn <br/>luôn là ưu tiên hàng đầu.",
      "Ngay từ giây phút đầu tiên tôi đã nghĩ chúng tôi sẽ tiến xa…",
      "Ban đầu, tui không tìm kiếm mối quan hệ lâu dài…",
      "Lời khuyên dành cho bất kỳ ai trên Badoo là hãy là chính mình...",
      "Câu Chuyện Thành Công Badoo",
      "Xem thêm câu chuyện thành công",
      "{{num}}__CUT__Xếp hạng",
      "Apple App Store",
      "Hãy tin chúng tôi. Chúng tôi đã gắn kết hàng triệu (và hàng triệu, hàng triệu) người với nhau kể từ năm 2006.",
      "{{num}}+Triệu__CUT__ Lượt tải",
      "{{num}}+Triệu",
      "Google Play Store",
      "Chúng tôi biết chúng tôi đang làm gì.",
      "Đăng nhập bằng email hoặc số điện thoại",
      "Điền mật khẩu",
      "Quên mật khẩu?",
      "Đăng ký",
      "Chưa có tài khoản?",
      "Đăng nhập",
      "Đăng ký"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "ký tự"
            ],
            "singular": [
                  "ký tự"
            ]
      },
      "day": {
            "plural": [
                  "ngày"
            ],
            "singular": [
                  "ngày"
            ]
      },
      "hour": {
            "plural": [
                  "giờ"
            ],
            "singular": [
                  "giờ"
            ]
      },
      "minute": {
            "plural": [
                  "phút"
            ],
            "singular": [
                  "phút"
            ]
      },
      "month": {
            "plural": [
                  "tháng"
            ],
            "singular": [
                  "tháng"
            ]
      },
      "second": {
            "plural": [
                  "giây"
            ],
            "singular": [
                  "giây"
            ]
      },
      "year": {
            "plural": [
                  "tuổi"
            ],
            "singular": [
                  "tuổi"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
